import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions/';
import { increaseQuizCount } from '~teacher/hook/useQuizLimit';
import { addQuizToCache, quizzesQueryKey } from '~teacher/hook/useQuizzes';
import { useProgress } from '~teacher/hook/utils/useProgress';

import { uniqueIdFactory } from '../../api/quiz/getQuizzes/normalize/uniqueIds';
import { importQuizToPersonalBySpreadsheet } from '../../api/quiz/importQuiz/importQuizToPersonalBySpreadsheet';

export function useImportQuizToPersonalBySpreadsheetMutation() {
  const queryClient = useQueryClient();
  const { progressPercent, onProgressEvent } = useProgress();

  const mutation = useMutation(
    // Mutation options (second argument to useMutation) - contains
    // onMutate, onError, onSettled, etc.
    {
      mutationFn: importQuizToPersonalBySpreadsheet(onProgressEvent),
      onMutate: () => {
        return queryClient.cancelQueries(quizzesQueryKey.quiz);
      },

      onSuccess: (importQuizByExcelResponse) => {
        const { date, id, name, sharable, soc, version, parentId } =
          importQuizByExcelResponse;

        const uniqueId: string = uniqueIdFactory.quiz.toUniqueId(id);

        // Manually update cache
        addQuizToCache(queryClient, {
          id: id,
          name: name,
          parentId: parentId,
          type: 'quiz',
          uniqueId: uniqueId,
          date: new Date(date),
          soc: soc,
          deleted: false,
          version: version,
          sharable: sharable,
          standard: null,
        });

        increaseQuizCount(queryClient);
        apiToaster([], QuizToastActions.IMPORT);
      },
      onError: (error) => {
        apiToaster([], QuizToastActions.IMPORT, error);
      },
      // react-query recommends always refetching after error or success
      onSettled: () => {
        return queryClient.invalidateQueries(quizzesQueryKey.quiz);
      },
    }
  );
  return { ...mutation, progressPercent };
}
